import React from 'react';

import plants from '../../../../../images/plants.svg';

const PlantsIconComponent = ({ height = '14px', width = height, altText = 'icon', selected }) => {
  return <img src={plants} alt={altText} style={{ width, height }} />;
};

export default PlantsIconComponent;
